import React, {useContext, useState, useEffect} from "react";

import { A11y } from "@churchofjesuschrist/eden-buttons";
import { Select } from "@churchofjesuschrist/eden-form-parts";
import { Stack } from "@churchofjesuschrist/eden-stack";
import { textColorTertiary } from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import versionService from "./version-service";
import languages from "../../utils/app-languages";
import UserPermissionsContext from "../../utils/permissions/user-permissions-context";
import withStrings from "../../utils/strings/with-strings";
import useManagedStrings from "../../utils/use-managed-strings";
import withConfiguration from "../../utils/with-configuration";
import LanguageContext from "../Layout/language-context";


const defaultService = versionService();

/*TODO: it would be nice potentially to get this version from the app settings by way of the configuration
context.  However, we would probably want to change that as part of a release, so we either change the version number
in an app settings file, a release variable
*/



const VersionHolder = styled.div`
  text-align: right;
  font-size: 0.8rem;
  color: ${textColorTertiary};
`;
const stringGroups = [
  {
    name: "shared",
    keys: [
      "settings",
      "language",
      "logout",
      "sendFeedback",
      "version",
      "impersonateUser",
      "wise",
      "platform",
      "requestHelp"
    ],
  },
];


const UserOptions = ({
  service = defaultService,
  onLanguageChosen = () => {},
  onLogOutClicked = () => {},
  onImpersonateClicked = () => {},
  onHelpClicked = () => {},
  closeMenu = () => {},
  strings,
  configuration = {}
}) => {
  const [version, setVersion] = useState();
  useEffect(() => {
    const load = async() => {
      try {
        const v = await service.getVersion();
        setVersion(v);
      } catch (e) {
        setVersion();
      }
    }
    load();
  },[service])

  const permissions = useContext(UserPermissionsContext);
  const contextLanguage = useContext(LanguageContext);
  let language = contextLanguage;
  const check = languages.find((l) => l.code === language);
  if (!check) {
    language = "en";
  }
  const {applicationId = 7} = configuration;
  const {managedStrings: useStrings} = useManagedStrings(stringGroups);
  const canImpersonate = permissions?.find((x) => {
    return (
      x.permission === "CanAdminApplication" &&
      x.targetId === applicationId.toString()
    );
  });

  return (
    <Stack data-id="user-options">
      {canImpersonate ? (
        <A11y onClick={() => {
          onImpersonateClicked();
          closeMenu();
        }}>
          {useStrings.impersonateUser}
        </A11y>
      ) : null}
      <Select
        onChange={(e) => {
          onLanguageChosen(e.target.value);
          closeMenu();
        }}
        defaultValue={language}
      >
        {languages.map((l) => (
          <option value={l.code} key={l.code}>
            {l.name}
          </option>
        ))}
      </Select>
      <A11y href="https://forms.office.com/r/K1ts3u2iQS" target="_blank" rel="noopener noreferrer">
        <React.Fragment>
          {useStrings.sendFeedback}
        </React.Fragment>
      </A11y>
      <A11y onClick={() => {
        onHelpClicked();
        closeMenu();
      }}>
        <React.Fragment>
          {useStrings.requestHelp}
        </React.Fragment>
      </A11y>
      <A11y onClick={() => {
        onLogOutClicked();
        closeMenu();
      }}>{useStrings.logout}</A11y>
      <VersionHolder>
        {version && <>
          {useStrings.wise}: {version.wiseVersion}<br/>
          {useStrings.platform}: {version.platformVersion}
        </>}
      </VersionHolder>
    </Stack>)

}
export default withConfiguration(withStrings(UserOptions));
